import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { PRIMARY_OUTLET, Router } from '@angular/router';
import { LocalStorageService } from '../../../../services/local-storage.service';
import { blank, data_get, filled, spf, transform } from '../../../utils/common';
import { omit } from 'lodash-es';
import { USER_HOME_LOCAL_STORE_KEY_SUFFIX } from '../../../utils/constants';
import { ClientStoreService } from '../../../../services/client-store.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'fieldmagic-mark-as-home-button',
  template: `
    <fieldmagic-icon
      purpose="clicking"
      tooltip="Mark/Unmark as home page"
      [icon]="[{
        icon: 'star',
        klass: (marked) ? 'text-warning' : 'text-reset',
        variant: (marked) ? 'solid' : 'regular'
      }]"
      position="center"
      (click)="onToggle()"
    >
    </fieldmagic-icon>
  `,
})
export class SetPageAsHomeButtonComponent implements OnInit, OnChanges {
  @Input()
  set params(params: Record<string, any>) {
    this._additional$.next(params);
  }

  marked: boolean = false;

  readonly _additional$ = new BehaviorSubject<Record<string, any>>({});

  constructor(
    private readonly _router: Router,
    private readonly _local: LocalStorageService,
    private readonly _client: ClientStoreService,
  ) {}

  ngOnInit(): void {
    this._mark();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (filled(data_get(changes, 'params'))) {
      this._mark();
    }
  }

  onToggle(): void {
    const tree = transform(this._router.url, {
      transformer: (value: string) => this._router.parseUrl(value),
    });

    if (blank(tree)) {
      return;
    }

    if (this.marked) {
      this._local.removeItem(this._buildStoreKey());
      this.marked = false;
      return;
    }

    const storable = this._router.serializeUrl(this._router.createUrlTree([tree.root.children[PRIMARY_OUTLET].children], {
      queryParams: {
        ... omit(tree.queryParams, [
          'page',
        ]),
        ... this._additional$.value,
      }
    }));

    this._local.setItem(this._buildStoreKey(), storable);

    this.marked = true;
  }

  private _buildStoreKey = () => spf('%s%s', {
    args: [
      data_get(this._client.getActiveClient(), 'client_id'),
      USER_HOME_LOCAL_STORE_KEY_SUFFIX,
    ],
  });

  private _mark(): void {
    const stored = this._local.getItem(this._buildStoreKey());

    if (blank(stored)) {
      this.marked = false;
      return;
    }

    const currentUrlTree = transform(this._router.url, {
      transformer: (value: string) => this._router.parseUrl(value),
    });

    if (blank(currentUrlTree)) {
      return;
    }

    this.marked = stored === this._router.serializeUrl(
      this._router.createUrlTree([currentUrlTree.root.children[PRIMARY_OUTLET].toString()], {
        queryParams: {
          ... omit(currentUrlTree.queryParams, [
            'page',
          ]),
          ... this._additional$.value,
        },
      }),
    );
  }
}
